import type { FC } from "react";

import BoxTitle from "pro-features/components/BoxTitle/src/BoxTitle";
import { GraphLoader } from "pro-features/components/Loaders/src/ExpandedTableRowLoader/ExpandedTableRowLoader";
import {
    ConversionHomepageContainer,
    PageDescription,
    PageTitle,
    TilesContainer,
} from "pro-features/pages/conversion/Homepage/src/StyledComponents";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import type { ISegmentsData } from "../../../services/conversion/ConversionSegmentsService";

import type { IGroup } from "./CustomGroupTiles";
import { CustomGroupTiles } from "./CustomGroupTiles";
import { StyledLeaderboardsHeaderContainer, StyledPrimaryTitle, TileWrapper } from "./StyledComponents";

interface IConversionHomepageProps {
    isLoading: boolean;
    customGroups: IGroup[];
    onCreate: () => void;
    translate: (key: string, params?) => string;
    components?: { ConversionLeaderboardContainer: any };
    segments?: ISegmentsData;
}

export const ConversionHomepage: FC<IConversionHomepageProps> = ({
    isLoading,
    customGroups,
    onCreate,
    translate,
    components,
    segments,
}) => {
    const { ConversionLeaderboardContainer } = components;
    return (
        <ConversionHomepageContainer>
            <FlexColumn>
                <PageTitle>{translate("conversion.homepage.title")}</PageTitle>
                <PageDescription>{translate("conversion.homepage.desc")}</PageDescription>

                <StyledLeaderboardsHeaderContainer>
                    <StyledPrimaryTitle>
                        <BoxTitle tooltip={translate("conversion.homepage.customgroup.tooltip")}>
                            {translate("conversion.homepage.customgroup.title")}
                        </BoxTitle>
                    </StyledPrimaryTitle>
                </StyledLeaderboardsHeaderContainer>
                {isLoading ? (
                    <TilesContainer>
                        <TileWrapper>
                            <GraphLoader
                                height={294}
                                width={"100%"}
                            />
                        </TileWrapper>
                        <TileWrapper>
                            <GraphLoader
                                height={294}
                                width={"100%"}
                            />
                        </TileWrapper>
                        <TileWrapper>
                            <GraphLoader
                                height={294}
                                width={"100%"}
                            />
                        </TileWrapper>
                    </TilesContainer>
                ) : (
                    [
                        <CustomGroupTiles
                            key={"customgrouptiles"}
                            segments={segments}
                            customGroups={customGroups}
                            onCreate={onCreate}
                        />,
                        <ConversionLeaderboardContainer
                            key={"conversionleaderboard"}
                            segments={segments}
                        />,
                    ]
                )}
            </FlexColumn>
        </ConversionHomepageContainer>
    );
};
